export default {
  brand: {
    name: "Arman Delivery",
    full: "Arman Delivery & Taxi",
    sub: "& Такси · Ереван",
  },
  language: {
    label: "Язык",
    en: "Английский",
    hy: "Армянский",
    ru: "Русский",
  },
  nav: {
    home: "Главная",
    services: "Услуги",
    fleet: "Автопарк",
    how: "Как арендовать",
    pricing: "Цены",
    service: "Сервисный центр",
    faq: "Вопросы",
    contact: "Контакты",
    callNow: "Позвонить",
    whatsapp: "Написать в WhatsApp",
  },
  wa: {
    nav: "Здравствуйте, Arman Delivery, хочу арендовать транспорт в Ереване",
    hero: "Здравствуйте, Arman Delivery, хочу арендовать мотоцикл в Ереване",
    fleet: "Здравствуйте, Arman Delivery, хочу арендовать {{vehicle}}",
    pricing: "Здравствуйте, Arman Delivery, меня интересует тариф {{plan}}",
    how: "Здравствуйте, Arman Delivery, хочу начать оформление аренды",
    service: "Здравствуйте, Arman, мне нужен сервис для моего транспорта",
    contact: "Здравствуйте, Arman Delivery, хочу арендовать транспорт",
    footer: "Здравствуйте, Arman Delivery, у меня есть вопрос",
    float: "Здравствуйте, Arman Delivery, нужна информация об аренде транспорта",
  },
  hero: {
    badge: "Армения · Ереван · С самого начала",
    title1: "Арендуй мотоцикл,",
    title2: "зарабатывай",
    title3: "каждый день",
    paragraph:
      "<b>{{brand}}</b> предлагает самую доступную недельную аренду мотоциклов, скутеров и автомобилей для курьеров в Ереване. Начни зарабатывать на платформах доставки еды и курьерских сервисах — мы берём на себя транспорт, сервис и запчасти.",
    ctaWhatsapp: "Написать в WhatsApp",
    ctaFleet: "Смотреть автопарк",
  },
  stats: {
    riders: "Курьеров обслужено",
    vehicles: "Активных машин",
    support: "Поддержка и сервис",
    rates: "Недельные цены в Ереване",
  },
  marquee: {
    bike: "Недельная аренда мото",
    scooter: "Аренда скутера",
    car: "Аренда авто",
    service: "Сервисный центр",
    parts: "Все запчасти",
    whatsapp: "Поддержка WhatsApp 24/7",
    location: "Улица Рубинянц 28/1, Зейтун",
  },
  services: {
    eyebrow: "Что мы предлагаем",
    title1: "Всё в одном месте",
    title2: "для курьеров в Армении",
    subtitle:
      "От аренды до сервиса и запчастей — Arman Delivery закрывает весь путь курьера.",
    learnMore: "Узнать больше",
    bike: {
      title: "Аренда мотоцикла",
      description:
        "Доступная недельная аренда мотоциклов для доставки еды, курьерской работы и личных поездок по Еревану.",
    },
    scooter: {
      title: "Аренда скутера",
      description:
        "Экономичные автоматические скутеры идеально подходят для городской доставки — по самой низкой недельной цене в городе.",
    },
    car: {
      title: "Аренда автомобиля",
      description:
        "Надёжные седаны и хэтчбеки для таксистов и курьеров на дальние маршруты.",
    },
    service: {
      title: "Сервисный центр",
      description:
        "Полный сервис на месте, замена масла, настройка и ремонт для всего транспорта, который мы сдаём в аренду.",
    },
    parts: {
      title: "Запчасти",
      description:
        "Оригинальные и OEM запчасти на складе, чтобы ваш транспорт не простаивал долго.",
    },
    roadside: {
      title: "Помощь на дороге",
      description:
        "Помощь при поломке по всему Еревану. Один звонок или сообщение в WhatsApp — и мы приезжаем к вам.",
    },
  },
  fleet: {
    eyebrow: "Наш автопарк",
    title1: "Выбери свой транспорт,",
    title2: "стандарт Еревана",
    subtitle:
      "Все недельные цены ниже соответствуют текущему стандарту рынка Еревана. Полная страховка, проверка на дороге и сервис в нашей мастерской.",
    weeklyRate: "Недельная цена",
    lease: "Взять",
    perWeek: "{{price}} AMD / неделя",
    fuelPetrol: "Бензин · {{value}} км/л",
    seats: "{{count}} места",
    categories: {
      all: "Все",
      bikes: "Мотоциклы",
      scooters: "Скутеры",
      cars: "Автомобили",
    },
    badges: {
      foodDelivery: "Лучший для доставки еды",
      mileage: "Самый экономичный мотоцикл",
      comfort: "Удобен для доставки",
      courier: "Мощный курьерский мотоцикл",
      taxi: "Лучший для таксистов",
      family: "Семейное такси",
      premium: "Премиум мотоцикл для доставки",
    },
  },
  how: {
    eyebrow: "Как арендовать",
    title: "Выезжай за 4 простых шага",
    subtitle: "Просто, быстро и прозрачно. Начни курьерскую карьеру с Arman уже сегодня.",
    cta: "Начать аренду сегодня",
    choose: {
      title: "Выбери транспорт",
      description:
        "Посмотри автопарк мотоциклов, скутеров и авто и выбери модель под свою работу и бюджет.",
    },
    docs: {
      title: "Отдай документы",
      description:
        "Возьми паспорт, права и одно фото. Мы составим простой недельный договор аренды прямо на месте.",
    },
    pay: {
      title: "Плати еженедельно",
      description:
        "Плати только за ту неделю, которую ездишь. Никаких длинных договоров, цены соответствуют стандарту рынка Еревана.",
    },
    ride: {
      title: "Езди и зарабатывай",
      description:
        "Забирай ключи и начинай зарабатывать на любой платформе доставки в Армении в тот же день.",
    },
  },
  pricing: {
    eyebrow: "Недельные цены",
    title1: "Недельная аренда",
    title2: "по стандартным ценам Еревана",
    subtitle:
      "Прозрачные цены без скрытых платежей. Вы платите только за ту неделю, которую ездите.",
    note: "Цены могут отличаться в зависимости от модели. Есть возвращаемый залог. Точную цену уточните в WhatsApp.",
    plans: {
      bike: {
        name: "Мотоцикл, неделя",
        tag: "Самая низкая цена",
        unit: "AMD / неделя",
        cta: "Арендовать мото",
        f1: "Идеально для доставки еды и курьерской работы",
        f2: "Оплата раз в неделю, без долгого договора",
        f3: "Бесплатное базовое обслуживание",
        f4: "Помощь на дороге включена",
        f5: "Шлем и короб для доставки — доп.",
      },
      scooter: {
        name: "Скутер, неделя",
        tag: "Самый популярный",
        unit: "AMD / неделя",
        cta: "Арендовать скутер",
        f1: "Автомат, легко управлять",
        f2: "Идеален для новичков",
        f3: "Еженедельная проверка сервиса",
        f4: "Приоритетный доступ к запчастям",
        f5: "Короб для доставки включён",
      },
      car: {
        name: "Автомобиль, неделя",
        tag: "Стандарт Еревана",
        unit: "AMD / неделя",
        cta: "Арендовать авто",
        f1: "Подходит для такси и дальней доставки",
        f2: "Полная страховка включена",
        f3: "Бесплатная замена масла каждый месяц",
        f4: "Варианты на 4-5 мест",
        f5: "Экономичные модели",
      },
    },
  },
  service: {
    eyebrow: "Сервисный центр и запчасти",
    title1: "Всё в одном месте.",
    title2: "От аренды до последнего болта.",
    subtitle:
      "Весь транспорт, который мы сдаём в аренду, полностью обслуживается в нашем сервисном центре на улице Рубинянц в Зейтуне. Поломка, мелкий ремонт или запчасть — всё делаем быстро, честно и по справедливой цене.",
    turnaround: "2 ч",
    turnaroundLabel: "Среднее время сервиса",
    rating: "Оценили 300+ курьеров",
    bookBtn: "Записаться на сервис",
    callBtn: "Позвонить в мастерскую",
    workshop: {
      title: "Полноценная мастерская",
      description: "Сертифицированные механики по мото, скутерам и авто под одной крышей.",
    },
    parts: {
      title: "Оригинальные запчасти",
      description: "Полный склад OEM и оригинальных деталей, чтобы ремонт не занимал дни.",
    },
    maintenance: {
      title: "Бесплатное базовое обслуживание",
      description: "Каждый арендованный транспорт получает бесплатную замену масла и проверку безопасности.",
    },
    guarantee: {
      title: "Гарантия качества",
      description: "30-дневная гарантия на каждый ремонт, выполненный в нашей мастерской.",
    },
  },
  testimonials: {
    eyebrow: "Истории курьеров",
    title1: "Нам доверяет",
    title2: "курьерское сообщество Еревана",
    davit: {
      role: "Курьер Glovo",
      quote:
        "Начал с Arman прошлым летом на мотоцикле Splendor. Недельная цена, честно говоря, самая низкая в Ереване, и когда нужен сервис, всё делают в тот же день.",
    },
    narek: {
      role: "Yandex Delivery",
      quote:
        "Их скутер спас меня от хаоса общественного транспорта. Бензин дешёвый, первый месяц сервис бесплатный. Очень рекомендую курьерам.",
    },
    aram: {
      role: "Таксист",
      quote:
        "Арендую авто у Arman на неделю для работы в такси. Прозрачная цена, без игр и сюрпризов. Склад запчастей просто отличный.",
    },
  },
  faq: {
    eyebrow: "Частые вопросы",
    title: "Всё, что вы хотите знать",
    documents: {
      q: "Какие документы нужны для аренды мото или авто?",
      a: "Нужны действующие армянские или международные права, паспорт или ID-карта, одно свежее фото и возвращаемый залог. Это всё, и мы составим простой недельный договор прямо на месте.",
    },
    weekly: {
      q: "Сколько стоит недельная аренда мото в Ереване?",
      a: "Недельная аренда мото начинается от 30 000 AMD, скутеры — от 17 000 AMD, автомобили — от 55 000 AMD. Цены соответствуют стандарту рынка Еревана и могут немного отличаться в зависимости от модели.",
    },
    support: {
      q: "Вы обслуживаете арендованный транспорт и даёте запчасти?",
      a: "Да. Весь транспорт, который мы сдаём, полностью обслуживается в нашем сервисном центре на улице Рубинянц. Базовое обслуживание бесплатно для арендаторов, а оригинальные запчасти всегда на складе.",
    },
    delivery: {
      q: "Можно использовать транспорт для доставки Glovo, Yandex или Wolt?",
      a: "Конечно. Наш автопарк создан для курьерской работы, и большинство наших водителей используют транспорт на Glovo, Yandex, Wolt и других курьерских платформах Еревана.",
    },
    breakdown: {
      q: "Что делать, если транспорт сломается во время смены?",
      a: "Позвоните или напишите нам в WhatsApp. Мы помогаем на дороге по всему Еревану и как можно быстрее отремонтируем или заменим неисправный транспорт, чтобы вы продолжали зарабатывать.",
    },
    sell: {
      q: "Вы продаёте запчасти клиентам без аренды?",
      a: "Да. Любой может купить запчасти в нашей мастерской, не только арендаторы. Приходите в магазин или напишите нам о нужной детали, чтобы узнать цену.",
    },
  },
  contact: {
    eyebrow: "Свяжитесь с нами",
    title1: "Давайте сегодня",
    title2: "отправим вас в путь",
    subtitle:
      "Приходите в мастерскую или напишите в WhatsApp — обычно отвечаем меньше чем за 5 минут.",
    whatsappTitle: "Напишите в WhatsApp",
    whatsappSub: "Самый быстрый ответ · 24/7",
    callTitle: "Позвоните напрямую",
    callHours: "Пн-Вс · 9:00 - 21:00",
    visitTitle: "Приезжайте в мастерскую",
    addressLine: "Улица Рубинянц 28/1, Зейтун",
    addressCity: "Ереван 0069, Армения",
    form: {
      title: "Отправить запрос на аренду",
      subtitle: "Расскажите, что нужно, и мы ответим в WhatsApp или по телефону.",
      name: "Имя и фамилия *",
      namePlaceholder: "Ваше имя",
      phone: "Телефон / WhatsApp *",
      email: "Эл. почта",
      vehicleLabel: "Интересующий транспорт *",
      vehiclePlaceholder: "Выберите вид транспорта",
      optionBike: "Аренда мото",
      optionScooter: "Аренда скутера",
      optionCar: "Аренда авто",
      optionService: "Сервис / ремонт",
      optionParts: "Запчасти",
      optionHero: "Hero Splendor (новый)",
      message: "Сообщение",
      messagePlaceholder: "Расскажите, что вам нужно...",
      maxChars: "Максимум 500 символов",
      submit: "Отправить",
      sending: "Отправка...",
      success: "Спасибо. Ваш запрос отправлен, мы свяжемся с вами в ближайшее время.",
      errorNetwork: "Ошибка сети. Попробуйте снова или напишите нам в WhatsApp.",
      errorGeneric: "Не удалось отправить запрос. Попробуйте снова или напишите нам в WhatsApp.",
    },
  },
  footer: {
    about:
      "Аренда мотоциклов, скутеров и авто — всё в одном месте в Ереване, Армения. Выезжай сегодня по самым низким недельным ценам в городе.",
    services: "Услуги",
    company: "Компания",
    contact: "Контакты",
    bike: "Аренда мото",
    scooter: "Аренда скутера",
    car: "Аренда авто",
    serviceCenter: "Сервисный центр",
    spare: "Запчасти",
    how: "Как арендовать",
    pricing: "Недельные цены",
    faq: "Частые вопросы",
    whatsappChat: "Чат в WhatsApp",
    hours: "Пн-Вс · 9:00 - 21:00",
    rights: "© 2026 Arman Delivery & Taxi. Все права защищены.",
    curated: "Сделано SkyEdge Infotech LLC",
  },
  whatsappFloat: "Напишите нам",
};